import template from './active-filter.pug';

export const ActiveFilterComponent = {
  template,
  bindings: {
    filter: '<?',
    module: '<',
    options: '<?',
    onFilterChange: '&',
  },
  controller: class ActiveFilterComponent {
    constructor(Table, Signal, $rootScope, User, $log, $async) {
      'ngInject';
      this.Table = Table;
      this.Signal = Signal;
      this.$rootScope = $rootScope;
      this.User = User;
      this.$log = $log;
      this.getUsers = $async(this.getUsers.bind(this));
      this.activeFilter = [];
      this.options = {};
    }

    $onChanges({ filter } = {}) {
      if (filter && filter.currentValue) {
        this.handleFilterChange(filter.currentValue);
      }
    }

    async $onInit() {
      await this.getUsers();
      if (this.module) {
        this.Signal.listen('filterChanged:' + this.module, this.$rootScope, (filter) => {
          this.handleFilterChange(filter);
        });
      }
    }

    handleFilterChange(filter) {
      this.filter = filter;
      this.activeFilter = this.mapActiveFilters(filter);
      Object.keys(this.activeFilter).length ? this.disabledClearFilter = false : this.disabledClearFilter = true;
    }

    mapActiveFilters(filter) {
      return this.Table.mapActiveFilters(filter, this.options);
    }

    clearFilterVal(key) {
      this.filter[key] = null;
      this.handleFilterChange(this.filter);
      this.Signal.send('onFilterColumnReset', key);
    }

    clearFilters() {
      (this.$rootScope.gridApi[this.module+'s-table'] || this.$rootScope.gridApi[this.module+'s-modal']).grid.clearAllFilters();
    }

    async getUsers() {
      try {
        const resp = await this.User.getList({ fields: { user: ['id', 'name'] } });
        this.options.users = [];
        resp.forEach(user => {
          this.options.users[user.id] = user.name;
        });
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
